module.exports = __webpack_public_path__ + "img/obt.66d044a0.png";